const insuranceRequestLanding = require('./insuranceRequest/insuranceRequestLanding');
const insuranceRequestProductDetailDescription = require('./insuranceRequest/insuranceRequestProductDetailDescription');
const insuranceRequestSimulation = require('./insuranceRequest/insuranceRequestSimulation');
const insuranceRequestState = require('./insuranceRequest/insuranceRequestState');
const insuranceRequestWizard = require('./insuranceRequest/insuranceRequestWizard');
const insuranceRequestRelatedState = require('./insuranceRequestRelated/insuranceRequestRelatedState');
const insuranceRequestRelatedWizard = require('./insuranceRequestRelated/insuranceRequestRelatedWizard');
const insuranceRequestRelatedRNCState = require('./insuranceRequestRelatedRNC/insuranceRequestRelatedRNCState');
const insuranceRequestRelatedRNCWizard = require('./insuranceRequestRelatedRNC/insuranceRequestRelatedRNCWizard');
const insurancesProfileDocumentation = require('./insurancesProfileDocumentation');
const insuranceRequestModify = require('./insuranceRequestRelated/insuranceRequestRelatedModify');
const insuranceRequestLegalDocuments = require('./insuranceLegalDocuments');
const insuranceChosenMortgage = require('./insuranceChosenMortgage');
const insuranceAssociatedMortgage = require('./insuranceAssociatedMortgage');

module.exports = {
    insuranceRequestLanding,
    insuranceRequestProductDetailDescription,
    insuranceRequestSimulation,
    insuranceRequestState,
    insuranceRequestWizard,
    insuranceRequestRelatedState,
    insuranceRequestRelatedWizard,
    insuranceRequestRelatedRNCState,
    insuranceRequestRelatedRNCWizard,
    insurancesProfileDocumentation,
    insuranceRequestModify,
    insuranceRequestLegalDocuments,
    insuranceChosenMortgage,
    insuranceAssociatedMortgage,
};
